/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setHeaderTransform.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ページURL取得
 */
var getPathName = location.pathname;
var pageName = /(department)/g;
/**
 * ヘッダー変形
 */
const setHeaderTransform = () => {
  if (getPathName.match(pageName)) {
    const sideNav = document.getElementById("sidebar");
    var targetElement = document.getElementById("aside");
    var clientRect = targetElement.getBoundingClientRect();
    var y = clientRect.top;
    var py = window.pageYOffset + clientRect.top;
    window.addEventListener("scroll", function () {
      if (window.pageYOffset > py - 84) {
        sideNav.classList.add("has__fixed");
      } else if (window.pageYOffset < py + 84) {
        sideNav.classList.remove("has__fixed");
      }
    });
  }
}

/**
 * ActionTo.
 */
export { setHeaderTransform }
